export default __webpack_public_path__ + "static/media/Web.6bdb6670.svg";